const makePaginatedListActions = type => [
  // getItems
  (params = {}) => ({
    type,
    payload: {
      params,
      reset: true,
    },
  }),
  // loadMoreItems
  (params = {}) => ({
    type,
    payload: {
      params,
      reset: false,
    },
  }),
  // unloadItems
  () => ({
    type: `${type}_UNLOAD`,
  }),
]

export default makePaginatedListActions



// WEBPACK FOOTER //
// ./src/actions/paginated.js